import { genericGet } from "../../../utils/genericApiCall";

export async function obtenerNivelEducacional() {
    const url_endpoint = '/ParNivelEducacionAfiliado/ObtenerTodo';
    const message_info = 'Obteniendo niveles educacionales...';
    const message_error = 'Error al obtener niveles educacionales...';

    return await genericGet({
        url_endpoint: url_endpoint,
        message_info: message_info,
        message_error: message_error
    });
}